export enum MediaType {
  AUDIO = 'audio',
  VIDEO = 'video',
  PDF = 'pdf',
  DOCUMENT = 'document',
  OTHER = 'other'
}
